var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003,1.9999 C17.5143,1.9999 22.0003,6.4859 22.0003,11.9999 C22.0003,17.5139 17.5143,21.9999 12.0003,21.9999 C6.4863,21.9999 2.0003,17.5139 2.0003,11.9999 C2.0003,6.4859 6.4863,1.9999 12.0003,1.9999 Z M10.70725,9.29325 C10.31625,8.90225 9.68425,8.90225 9.29325,9.29325 C8.90225,9.68425 8.90225,10.31625 9.29325,10.70725 L9.29325,10.70725 L10.58625,12.00025 L9.29325,13.29325 C8.90225,13.68425 8.90225,14.31625 9.29325,14.70725 C9.48825,14.90225 9.74425,15.00025 10.00025,15.00025 C10.25625,15.00025 10.51225,14.90225 10.70725,14.70725 L10.70725,14.70725 L12.00025,13.41425 L13.29325,14.70725 C13.48825,14.90225 13.74425,15.00025 14.00025,15.00025 C14.25625,15.00025 14.51225,14.90225 14.70725,14.70725 C15.09825,14.31625 15.09825,13.68425 14.70725,13.29325 L14.70725,13.29325 L13.41425,12.00025 L14.70725,10.70725 C15.09825,10.31625 15.09825,9.68425 14.70725,9.29325 C14.31625,8.90225 13.68425,8.90225 13.29325,9.29325 L13.29325,9.29325 L12.00025,10.58625 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1cec7a92.svg";
export { ForwardRef as ReactComponent };